import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import type { PolicyOption } from './useProjectionForPolicy';

// Redirects to a sensible default policy when:
//   - no policyId is present in the URL, or
//   - the URL's policyId no longer exists on the client (stale link).
// Prefers the first policy that actually has a projection; falls back to
// the first policy of any kind.
export function useRedirectToDefaultPolicy(
  clientId: string | undefined,
  policyId: string | undefined,
  options: PolicyOption[],
): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (!clientId || options.length === 0) return;

    const policyExists = policyId && options.some(o => o.fundingSourceId === policyId);
    if (policyExists) return;

    const fallback = options.find(o => o.hasProjection) ?? options[0];
    navigate(`/clients/${clientId}/projection-details/${fallback.fundingSourceId}`, {
      replace: true,
    });
  }, [clientId, policyId, options, navigate]);
}
